import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useIdentity } from '../../auth/useIdentity';

/**
 * Renders its children only for an account with the admin role.
 *
 * Wraps a whole route, so a page behind it is not even mounted for anybody else and never
 * fires the requests the API would refuse with 403. That matters for deeplinks in
 * particular: someone who opens one without the role gets a sentence instead of a page of
 * failed calls. The API is still what enforces it; this is the courtesy.
 */
export const AdminOnly = ({ children }: { children: ReactNode }) => {
    const { isAdmin, status, error, reload } = useIdentity();

    if (status === 'loading') {
        return (
            <main className="main-padding">
                <b>Loading</b>
            </main>
        );
    }

    if (status === 'error') {
        return (
            <main className="main-padding">
                <div className="alert alert-warning" role="alert">
                    Kon niet vaststellen welke rechten je hebt, dus deze pagina
                    blijft dicht. {error}{' '}
                    <button
                        type="button"
                        className="btn btn-link p-0 align-baseline"
                        onClick={reload}
                    >
                        Opnieuw proberen
                    </button>
                </div>
            </main>
        );
    }

    if (!isAdmin) {
        return (
            <main className="main-padding">
                <div className="alert alert-warning" role="status">
                    Deze pagina is alleen voor beheerders.
                </div>
                <Link to="/dashboard" className="btn btn-outline-secondary">
                    Naar het dashboard
                </Link>
            </main>
        );
    }

    return <>{children}</>;
};
